import { useEffect } from 'react';

export function useSearchCounter() {
  const incrementSearchCount = () => {
    const currentCount = parseInt(localStorage.getItem('totalSearchCount') || '0');
    localStorage.setItem('totalSearchCount', (currentCount + 1).toString());
  };

  return { incrementSearchCount };
}